import utils from "../modules/utils.js";
import { START } from "../constants/action-types";
import { SET_TIPO } from "../constants/action-types";
import { SET_PRODOTTO } from "../constants/action-types";
import { SET_DOVE } from "../constants/action-types";
import { SET_CF } from "../constants/action-types";
import { SET_DATI_PERSONALI } from "../constants/action-types";
import { SET_CONSENSI } from "../constants/action-types";
import { SET_GIORNO } from "../constants/action-types";
import { SET_GIORNO_ONLY } from "../constants/action-types";
import { SET_ORARIO } from "../constants/action-types";
import { SET_FILIALE } from "../constants/action-types";
import { CLEAR_FILIALI } from "../constants/action-types";
import { CLEAR_CONSENSI } from "../constants/action-types";
import { SET_FILIALI } from "../constants/action-types";
import { SET_DISPONIBILITA } from "../constants/action-types";
import { SET_RECAP } from "../constants/action-types";
import { CLEAR_DISPONIBILITA } from "../constants/action-types";
import { SET_VECCHIO_APPUNTAMENTO } from "../constants/action-types";
import { SET_OPP_ID } from "../constants/action-types";
import { SET_PRODUCT_FROM_PARAMS } from "../constants/action-types";
import { SET_DOVE_NO_RESET } from "../constants/action-types";
import { SET_UTM } from "../constants/action-types";
import { SET_FLUSSO_MODIFICA } from "../constants/action-types";
import { SET_MODIFICANDO } from "../constants/action-types";
import { SET_HISTORY_BACK } from "../constants/action-types";
import { CLEAR_HISTORY_BACK } from "../constants/action-types";
import { START_BACK_EVENT } from "../constants/action-types";
import { END_BACK_EVENT } from "../constants/action-types";
import { SAVE_TOKEN } from "../constants/action-types";
import { GET_DATA_FROM_TOKEN } from "../constants/action-types";
import { SET_LAST_BACK_TIMESTAMP } from "../constants/action-types";
import { SET_SOURCE } from "../constants/action-types";
import { SET_FIRST_LOAD } from "../constants/action-types";
import { SET_CAP_EXCLUDED } from "../constants/action-types";
import { SET_FOUND_DB_COMPASS } from "../constants/action-types";
import { SET_TELEFONICO } from "../constants/action-types";
import { SET_FAFUNNEL_TRIGGERED } from "../constants/action-types";
import { SET_OVERLAY } from "../constants/action-types";
import { SET_FLOW_SWITCH } from "../constants/action-types";
import { SET_RICONTATTO } from "../constants/action-types";
import { SET_RICONTATTO_CF } from "../constants/action-types";
import { SET_RICONTATTO_RICHIESTO } from "../constants/action-types";
import { SET_FILIALE_RICONTATTO } from "../constants/action-types";
import { SET_ACCESS_ROUTE } from "../constants/action-types";

const initialState = {
  "overlay": {
    "loader": {
      isVisible: true,
    }
  },
  "modificando": false,
  "flusso_modifica": false,
  "product_from_param": false,
  "tipo_appuntamento": "standard",
  "recap_cf_accettato": false,
  "oppID": "",
  "prodotto": "",
  "luogo": "",
  "coordinate_luogo": {
      "lat": "",
      "lng": ""
  },
  "data_appuntamento": "",
  "orario_appuntamento": "",
  "filiale": "",
  "id_filiale": "",
  "indirizzo_filiale": "",
  "utente": {},
  "dati_locali": {},
  "cap_excluded": false,
  "found_db_compass": false,
  "telefonico_forzato": false,
  "GTMEvents": {
    "faFunnelTriggered": false,
  },
  "flowSwitch": {
    goToNextStepAutomatically: false,
    previousFlow: 0,
  },
  "ricontatto": false,
  "ricontatto_cf": false,
  "ricontatto_richiesto": false,
  "filiale_ricontatto": "",
  "access_route": "/fissa-appuntamento"
};

function rootReducer(state = initialState, action) {
    let new_state = state;
    if (action.type === START) {
        new_state = Object.assign({}, state, initialState);
    } else if (action.type === SET_TIPO) {
        new_state = Object.assign({}, state, {
            tipo_appuntamento: action.payload
        });
    } else if (action.type === SET_FIRST_LOAD) {
      new_state = Object.assign({}, state, {
        app_loaded: true
      });
    } else if (action.type === SET_ACCESS_ROUTE) {
      new_state = Object.assign({}, state, {
        access_route: action.payload
      });
    } else if (action.type === SET_PRODOTTO) {
        let in_prodotto = action.payload ? action.payload : '';
        new_state = Object.assign({}, state, {
            prodotto: in_prodotto
        });
    } else if (action.type === SET_DOVE) {
        let in_luogo = action.payload && action.payload.luogo ? action.payload.luogo : '';
        let in_coords = action.payload && action.payload.coordinate_luogo ? action.payload.coordinate_luogo : '';
        new_state = Object.assign({}, state, {
            luogo: in_luogo,
            coordinate_luogo: in_coords,
            data_appuntamento: '',
            id_filiale: '',
            filiale: '',
            orario_appuntamento: ''
        });
    } else if (action.type === SET_GIORNO) {
        new_state = Object.assign({}, state, {
            data_appuntamento: action.payload,
            id_filiale: '',
            filiale: '',
            orario_appuntamento:''
        });
    } else if (action.type === SET_GIORNO_ONLY) {
        new_state = Object.assign({}, state, {
            data_appuntamento: action.payload,
        });
    } else if (action.type === SET_ORARIO) {
        new_state = Object.assign({}, state, {
            orario_appuntamento: action.payload
        });
    } else if (action.type === SET_FILIALE) {
        new_state = Object.assign({}, state, {
            id_filiale: action.payload.id,
            filiale: action.payload.nome,
            indirizzo_filiale: action.payload.indirizzo
        });
    }  else if (action.type === SET_CF) {
        new_state = Object.assign({}, state, {
            utente: {
                ...state.utente,
                codice_fiscale: action.payload
            }
        });
    } else if (action.type === SET_DATI_PERSONALI) {
        let dl = state.dati_locali;

        if (action.payload.nome || action.payload.cancella_dati_locali) {
            dl.utente = {
                token: action.payload.cancella_dati_locali ? '' : action.payload.token,
                nome: action.payload.cancella_dati_locali ? '' : action.payload.nome,
                cognome: action.payload.cancella_dati_locali ? '' : action.payload.cognome,
                email: action.payload.cancella_dati_locali ? '' : action.payload.email,
                telefono: action.payload.cancella_dati_locali ? '' : action.payload.telefono,
                cap: action.payload.cancella_dati_locali ? '' : action.payload.cap,
                provincia: action.payload.cancella_dati_locali ? '' : action.payload.provincia,
                comune: action.payload.cancella_dati_locali ? '' : action.payload.comune,
                impiego: action.payload.cancella_dati_locali ? '' : action.payload.impiego,
                iscrittoCameraCommercio: action.payload.cancella_dati_locali ? '' : action.payload.iscrittoCameraCommercio,
                tipoAzienda: action.payload.cancella_dati_locali ? '' : action.payload.tipoAzienda,
            }
        }
        new_state = Object.assign({}, state, {
            utente: {
                ...state.utente,
                token: action.payload.token,
                nome: action.payload.nome,
                cognome: action.payload.cognome,
                email: action.payload.email,
                telefono: action.payload.telefono,
                cap: action.payload.cap,
                provincia: action.payload.provincia,
                comune: action.payload.comune,
                impiego: action.payload.impiego,
                iscrittoCameraCommercio: action.payload.iscrittoCameraCommercio,
                tipoAzienda: action.payload.tipoAzienda,
            },
            dati_locali: dl
        });
    } else if (action.type === SET_CONSENSI) {
        new_state = Object.assign({}, state, {
            utente: {
                ...state.utente,
                consensi: action.payload,
            }
        });
    } else if (action.type === SET_DOVE_NO_RESET) {
        let in_luogo = action.payload && action.payload.luogo ? action.payload.luogo : '';
        let in_coords = action.payload && action.payload.coordinate_luogo ? action.payload.coordinate_luogo : '';
        new_state = Object.assign({}, state, {
            luogo: in_luogo,
            coordinate_luogo: in_coords
        });
    } else if (action.type === CLEAR_FILIALI) {
        new_state = Object.assign({}, state, {
            dati_locali: {
                ...state.dati_locali,
                filiali: null
            }
        });
    } else if (action.type === SET_FILIALI) {
        new_state = Object.assign({}, state, {
            dati_locali: {
                ...state.dati_locali,
                filiali: action.payload
            }
        });
    } else if (action.type === SET_CAP_EXCLUDED) {
      new_state = Object.assign({}, state, {
        cap_excluded: action.payload
      });
    } else if (action.type === SET_DISPONIBILITA) {
        let filiali_new = state.dati_locali.filiali ? state.dati_locali.filiali.filiali : [];
        let disponibilita = action.payload;
        for (let i = 0; i < filiali_new.length; i++) {
            let f = filiali_new[i];
            let idFiliale = f.idFiliale;
            if (idFiliale == disponibilita.codFiliale) {
                if (!filiali_new[i].hasOwnProperty('disponibilita')) {
                    filiali_new[i]["disponibilita"] = [];
                }
                filiali_new[i]["disponibilita"].push(disponibilita);
                console.log(filiali_new[i])
            }
        }
        new_state = Object.assign({}, state, {
            dati_locali: {
                ...state.dati_locali,
                filiali: {
                    ...state.dati_locali.filiali,
                    filiali: filiali_new
                }
            }
        });
    } else if (action.type === SET_RECAP) {
        new_state = Object.assign({}, state, {
            recap_cf_accettato: action.payload
        });
    } else if (action.type === CLEAR_DISPONIBILITA) {
        let filiali_new = state.dati_locali.filiali ? state.dati_locali.filiali.filiali : [];
        for (let i = 0; i < filiali_new.length; i++) {
            filiali_new[i]["disponibilita"] = [];
        }
        new_state = Object.assign({}, state, {
            dati_locali: {
                ...state.dati_locali,
                filiali: {
                    ...state.dati_locali.filiali,
                    filiali: filiali_new
                }
            }
        });
    } else if (action.type === SET_VECCHIO_APPUNTAMENTO) {
        new_state = Object.assign({}, state, {
            dati_locali: {
                ...state.dati_locali,
                vecchio_appuntamento: action.payload
            }
        });
    } else if (action.type === SET_OPP_ID) {
        new_state = Object.assign({}, state, {
            oppID: action.payload
        });
    } else if (action.type === SET_PRODUCT_FROM_PARAMS) {
        new_state = Object.assign({}, state, {
            product_from_param: action.payload
        });
    } else if (action.type === SET_UTM) {
        new_state = Object.assign({}, state, {
            dati_locali: {
                ...state.dati_locali,
                utm: action.payload
            }
        });
    } else if (action.type === SET_FLUSSO_MODIFICA) {
        new_state = Object.assign({}, state, {
            flusso_modifica: action.payload
        });
    } else if (action.type === SET_MODIFICANDO) {
        new_state = Object.assign({}, state, {
            modificando: action.payload,
        });
    } else if (action.type === CLEAR_CONSENSI) {
        new_state = Object.assign({}, state, {
            utente: {
                ...state.utente,
                consensi: {},
            }
        });
    } else if (action.type === SET_HISTORY_BACK) {
        new_state = Object.assign({}, state, {
            dati_locali: {
                ...state.dati_locali,
                historyBack: true
            }
        });
    } else if (action.type === CLEAR_HISTORY_BACK) {
        new_state = Object.assign({}, state, {
            dati_locali: {
                ...state.dati_locali,
                historyBack: false
            }
        });
    } else if (action.type === START_BACK_EVENT) {
        new_state = Object.assign({}, state, {
            dati_locali: {
                ...state.dati_locali,
                processingBack: true,
            }
        });
    } else if (action.type === END_BACK_EVENT) {
        new_state = Object.assign({}, state, {
            dati_locali: {
                ...state.dati_locali,
                processingBack: false,
            }
        });
    } else if (action.type === SAVE_TOKEN) {
        new_state = Object.assign({}, state, {
            utente: {
                ...state.utente,
                token: action.payload,
            }
        })
    } else if (action.type === GET_DATA_FROM_TOKEN) {
        new_state = Object.assign({}, state, {
            tipo_appuntamento: 'standard',
            prodotto: action.payload.prodotto ? action.payload.prodotto : '',
            utente: {
                ...state.utente,
                nome: action.payload.nome,
                cognome: action.payload.cognome,
                email: action.payload.email,
                telefono: action.payload.telefonoCell,
                cap: action.payload.cap,
                codice_fiscale: action.payload.codiceFiscale,
            }
        });
    } else if (action.type === SET_LAST_BACK_TIMESTAMP) {
      new_state = Object.assign({}, state, {
        last_back_timestamp : utils.getTimestamp()
      })
    } else if (action.type === SET_SOURCE) {
      new_state = Object.assign({}, state, {
        source: action.payload
      })
    } else if (action.type === SET_FOUND_DB_COMPASS) {
      new_state = Object.assign({}, state, {
        found_db_compass: action.payload
      })
    } else if (action.type === SET_TELEFONICO) {
      new_state = Object.assign({}, state, {
        telefonico_forzato: action.payload
      })
    } else if (action.type === SET_RICONTATTO) {
      new_state = Object.assign({}, state, {
        ricontatto: action.payload
      })
    } else if (action.type === SET_RICONTATTO_CF) {
      new_state = Object.assign({}, state, {
        ricontatto_cf: action.payload
      })
    } else if (action.type === SET_RICONTATTO_RICHIESTO) {
      new_state = Object.assign({}, state, {
        ricontatto_richiesto: action.payload
      })
    } else if (action.type === SET_FILIALE_RICONTATTO) {
      new_state = Object.assign({}, state, {
        filiale_ricontatto: action.payload
      })
    } else if (action.type === SET_FAFUNNEL_TRIGGERED) {
      new_state = Object.assign({}, state, {
        ...state,
        GTMEvents: {
          ...state.GTMEvents,
          faFunnelTriggered: action.payload
        }
      })
    } else if (action.type === SET_OVERLAY) {
      const newOverlay = { ...state.overlay, ...action.payload };
      new_state = {
        ...state,
        overlay: newOverlay,
      };
    } else if (action.type === SET_FLOW_SWITCH) {
      const newFlowSwitch = { ...state.flowSwitch, ...action.payload };
      new_state = {
        ...state,
        flowSwitch: newFlowSwitch,
      };
    }
    if (window && window.localStorage) {
      window.localStorage.setItem("appuntamento", JSON.stringify(new_state));
    }
    return new_state;
};

export default rootReducer;


// WEBPACK FOOTER //
// ./src/reducers/index.js